export const SECRET_KEY = process.env.REACT_APP_SECRET_KEY; 
export const BASE_EXCEL_URL = process.env.REACT_APP_EXCEL_SAMPLE_URL;
export const BASE_URL = process.env.REACT_APP_BASE_URL; //!API BASE URL
export const BASE_URL_IMG =   process.env.REACT_APP_BASE_URL_IMG; //!Image BASE URL
export const GMAIL_ADDRESS_KEY =   process.env.REACT_APP_GOOGLE_MAPS_API_KEY; //!Gmail Address Key
export const DEBUG_MODE = process.env.REACT_APP_DEBUG_MODE === "true" ? true : false;
export const RUPEES_SYMBOL = "₹";

export const slotDuration = [
  { "value": 5, "label": "5 min" },
  { "value": 10, "label": "10 min" },
  { "value": 15, "label": "15 min" },
  { "value": 20, "label": "20 min" },
  { "value": 25, "label": "25 min" },
  { "value": 30, "label": "30 min" },
  { "value": 35, "label": "35 min" },
  { "value": 40, "label": "40 min" },
  { "value": 45, "label": "45 min" },
  { "value": 50, "label": "50 min" },
  { "value": 55, "label": "55 min" },
  { "value": 60, "label": "60 min" }
]
 
export const DAYS = ["monday", "tuesday", "wednesday", "thursday", "friday", "saturday", "sunday"];
export const SESSIONS = [
  { value: "morning", label: "Morning" },
  { value: "afternoon", label: "Afternoon" },
  { value: "evening", label: "Evening" },
  { value: "night", label: "Night" },
];
 
export const icuNicuOptions = [
    { label: 'Only ICU', value: 'icu' },
    { label: 'Only NICU', value: 'nicu' },
    { label: 'Both ICU and NICU', value: 'both' },
    { label: 'None', value: 'none' },
  ];

